import { Pipe, PipeTransform } from '@angular/core'
import { CyclerStatus } from '@naturalcycles/shared'

const CYCLER_STATUS_MAP: Record<CyclerStatus, string> = {
  [CyclerStatus.newbie]: 'Newbie Cycler',
  [CyclerStatus.junior]: 'Junior Cycler',
  [CyclerStatus.skilled]: 'Skilled Cycler',
  [CyclerStatus.pro]: 'Pro Cycler',
  [CyclerStatus.star]: 'Star Cycler',
}

@Pipe({
  name: 'cyclerStatus',
})
export class CyclerStatusPipe implements PipeTransform {
  transform(cyclerStatus?: CyclerStatus): string {
    return CYCLER_STATUS_MAP[cyclerStatus || CyclerStatus.newbie]
  }
}
